import { IotGateModel } from "../models/iot-gate.model"
import { HttpResponse, Request } from "./request"
import { IotControlOpenGateResponseModel } from "@/app/models/iot-control-open-gate-response.model"

const request = Request("/iotControl")

export async function findAllGatesForFacility(
  facilityId: string,
): Promise<HttpResponse<IotGateModel[]>> {
  return request()
    .method("GET")
    .url(`/gates/${facilityId}`)
    .isList()
    .returns(IotGateModel)
    .fire()
}

export async function openGateByBooking(
  bookingId: string,
  iotDeviceGateId: number,
): Promise<HttpResponse<IotControlOpenGateResponseModel>> {
  return request()
    .method("PUT")
    .url(`/gates`)
    .data({
      bookingId,
      iotDeviceGateId,
    })
    .returns(IotControlOpenGateResponseModel)
    .fire()
}
